<template>
  <div>

    <!-- toolbar -->
    <v-layout 
    v-if="localWidgetMode === 0"
    align-center style="min-height: 56px;">
      <transition
      name="slide-x-reverse-transition"
      mode="out-in">

        <div 
        v-if="localSelected.length === 0"
        key="1"
        class="c-flex-r align-center subheading">

          <!-- select menu -->
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>mdi-check-box-multiple-outline</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
              @click="selectAll">
                <v-list-item-title>Select all</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn outlined @click="clickAddItem">
            <v-icon>mdi-plus</v-icon>
            New
          </v-btn>

        </div>

        <div v-else-if="localSelected.length > 0"
        key="2"
        class="c-flex-r align-center subheading">
          <v-btn
          icon
          class=""
          @click="localSelected = []">
            <v-icon color="color1">close</v-icon>
          </v-btn>
          <div class="text-sans font-weight-bold">
            <span>&nbsp;{{ localSelected.length }}</span>
            selected 
          </div>
          <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
          <span class="icon--text ml-2">|</span>
          <v-btn 
          icon
          @click="deleteSelected">
            <v-icon>delete_outline</v-icon>
          </v-btn>
          <!-- select menu -->
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>mdi-check-box-multiple-outline</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
              @click="selectAll">
                <v-list-item-title>Select all</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectNone">
                <v-list-item-title>Select none</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

      </transition>
    </v-layout>

    <!-- NEW -->
    <v-layout v-if="showNewRow"
    align-center class="">

      <v-icon small>
        mdi-chevron-right
      </v-icon>

      <v-icon small color="color1">
        mdi-label
      </v-icon>

      <div style="width: 40px;">

      </div>

      <v-text-field
      v-model="newItemTitle"
      hide-details
      clearable
      class="pt-0"
      ref="newItemTextField"
      color="color1"
      @blur="delayedBlur"
      @keydown.enter="createRootItem"
      ></v-text-field>

      <v-btn v-if="newItemTitle"
      text
      small
      color="color1"
      class="ml-2 white--text" @click="createRootItem">
        Create
      </v-btn>
      <v-btn v-else
      icon
      small
      class="ml-2 white--text" color="color1" @click="showNewRow = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>

    </v-layout>
    <!-- NEW -->

    <v-layout 
    v-if="false"
    align-center class="pa-2">

      <v-text-field
      v-model="newItemTitle"
      hide-details
      class="crx-box-input"
      color="color1"
      @keydown.enter="createRootItem"
      solo></v-text-field>

      <v-btn depressed class="ml-2 white--text" color="color1" @click="createRootItem">
        Create
      </v-btn>

    </v-layout>

    <div class="">
      <c-tree-view 
      :items="items" 
      :onClick="onClick" 
      :createNewItem="createNewItem" 
      :renameItem="renameItem" 
      :onDelete="onDelete" 
      :editable="editable"
      :selected.sync="localSelected" 
      :widgetMode="localWidgetMode">
      </c-tree-view>
    </div>

    <div v-if="localWidgetMode === 1">
      <v-chip color="color1" @click:close="localSelected.splice(localSelected.indexOf(selectedID), 1)" outlined close v-for="selectedID in localSelected" :key="selectedID">
        {{ itemMap[selectedID].name }}
      </v-chip>
    </div>

    <!--
    <div style="height: 200px;"></div>
    <v-card class="mt-4">
      {{ items }}
    </v-card>

    <v-treeview 
    :items="items" 
    selectable>
    
    </v-treeview>
    -->

    <v-layout align-center justify-end class="pa-1 border-t--thin">
      <v-menu offset-y
      :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn
            text
            small
            color="color1"
            class="caption"
            v-on="on"
          >
            {{ localWidgetMode }}
            &nbsp;-&nbsp;
            <span v-if="localWidgetMode === 0">Normal</span>
            <span v-else-if="localWidgetMode === 1">Select Multiple</span>
            <span v-else-if="localWidgetMode === 2">Select single</span>
            <span v-else-if="localWidgetMode === 3">Folder mode</span>
            <v-icon small>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-card class="pa-2">

          <v-layout justify-center>
            <span class="caption text-uppercase text--text text--darken-1">Widget Mode</span>
          </v-layout>

          <div class="c-hr ma-2"></div>

          <v-list>

            <v-list-item
            @click="localWidgetMode = 0">
              <v-list-item-title
              :class="[{'color1--text' : localWidgetMode === 0}]">
                0: Normal
              </v-list-item-title>
            </v-list-item>

            <v-list-item
            @click="localWidgetMode = 1">
              <v-list-item-title
              :class="[{'color1--text' : localWidgetMode === 1}]">
                1: Select Multiple
              </v-list-item-title>
            </v-list-item>

            <v-list-item
            @click="localWidgetMode = 2">
              <v-list-item-title
              :class="[{'color1--text' : localWidgetMode === 2}]">
                2: Select single
              </v-list-item-title>
            </v-list-item>

            <v-list-item
            @click="localWidgetMode = 3">
              <v-list-item-title
              :class="[{'color1--text' : localWidgetMode === 3}]">
                3: Folder
              </v-list-item-title>
            </v-list-item>

          </v-list>
        </v-card>
      </v-menu>
    </v-layout>

  </div>
</template>

<script>
import axios from 'axios'
import CTreeView from '@/components/ui/tree-view/C-TreeView'
import Vue from 'vue'

export default {
  props: {
    selected: null,
    widgetMode: 0,
    // 0 = normal
    // 1 = select multiple
    // 2 = select single
    // 3 = folder mode
    onClick: Function,
    editable: null
  },
  components: {
    CTreeView
  },
  data () {
    return {
      showNewRow: false,
      newItemTitle: '',
      idCounter: 5,
      items: [],
      itemMap: {},
      localSelected: [],
      localWidgetMode: this.widgetMode
    }
  },
  watch: {
    selected (nv) {
      this.localSelected = nv
    },
    localSelected (nv) {
      this.$emit('update:selected', nv)
    }
  },
  methods: {
    selectAll () {
      this.items.forEach(child => {
        this.checkTier(child)
      })
    },
    checkTier (item) {
      if (!this.localSelected.includes(item.id)) {
        this.localSelected.push(item.id)
      }
      if (item.children) {
        item.children.forEach(child => {
          this.checkTier(child)
        })
      }
    },
    selectNone () {
      this.localSelected = []
    },
    nodeFunction (arr, func) {
      // Runs a function for each node
      for (var i = arr.length - 1; i >= 0; --i) {
        this.nodeTier(arr[i], null, func)
      }
      /* arr.forEach(child => {
        this.nodeTier(child, null, func)
      }) */
    },
    nodeTier (item, parent, func) {
      func(item, parent)
      if (item.children) {
        for (var i = item.children.length - 1; i >= 0; --i) {
          this.nodeTier(item.children[i], item, func)
        }

        /* item.children.forEach(child => {
          this.nodeTier(child, item, func)
        }) */
      }
    },
    deleteSelected () {
      this.onDelete(this.localSelected)
        .then((confirm) => {
          if (confirm) {
            this.localSelected = []
          }
        })
    },
    axiosDelete (arr) {
      return new Promise((resolve, reject) => {
        this.$axios.post('categories/delete', arr,
          {headers: {'Content-Type': 'application/json'}})
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    },
    onDelete (arr) {
      return new Promise((resolve, reject) => {
        var title = 'Delete ' + arr.length + ' categor' + (arr.length === 1 ? 'y' : 'ies') + '?'
        this.$root.$confirm(title, 'Are you sure?', { color: 'purple' })
          .then((confirm) => {
            if (confirm) {
              this.axiosDelete(arr)
                .then(() => {
                  this.loadAPI()
                })
            }
            resolve(confirm)
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
      /* this.nodeFunction(this.items, (item, parent) => {
        if (arr.includes(item.id)) {
          if (parent) {
            var index = parent.children.indexOf(item)
            parent.children.splice(index, 1)
          } else {
            var index = this.items.indexOf(item)
            this.items.splice(index, 1)
          }
        }
      }) */
    },
    createRootItem () {
      /* this.idCounter ++
      this.items.push({
        id: this.idCounter,
        name: this.newItemTitle,
        children: []
      })
      this.newItemTitle = '' */
      this.axiosCreateNewItem(this.newItemTitle, {id: null})
        .then(() => {
          this.newItemTitle = ''
        })
    },
    axiosCreateNewItem (name, parent) {
      return new Promise((resolve, reject) => {
        let data = {
          name: name,
          parent: parent.id,
          category: 0
        }
        this.$axios.post('categories/add',
          data,
          {headers: {'Content-Type': 'application/json'}})
          .then(response => {
            this.loadAPI()
          })
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    },
    createNewItem (name, parent) {
      this.axiosCreateNewItem(name, parent)

      /*
      this.idCounter ++
      if (!parent.children) {
        Vue.set(parent, 'children', [])
        // parent.children = []
      }
      parent.children.push({
        id: this.idCounter,
        name: name,
        children: []
      })
      */
    },
    axiosPatchItem (item, name) {
      return new Promise((resolve, reject) => {
        let data = {
          name: name
        }
        this.$axios.patch(`categories/${item.id}`,
          data,
          {headers: {'Content-Type': 'application/json'}})
          .then(response => {
            this.loadAPI()
          })
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    },
    renameItem (item, name) {
      this.axiosPatchItem(item, name)
    },
    delayedBlur () {
      setTimeout(() => {
        this.showNewRow = false
      }, 150)
    },
    clickAddItem () {
      this.showNewRow = true
      this.$nextTick(() => {
        this.$refs.newItemTextField.focus()
      })
    },
    loadAPI () {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        axios.all([
          this.$axios.get(`/categories`)
        ])
        .then(axios.spread((response) => {
          this.items = []
          this.itemMap = {}
          response.data.forEach(row => {
            if (row.parent) {
              var insertion = {
                id: row.id,
                name: row.name,
                children: []
              }
              this.itemMap[row.id] = insertion
              var parent = this.itemMap[row.parent]
              parent.children.push(insertion)
            } else {
              var insertion = {
                id: row.id,
                name: row.name,
                children: []
              }
              this.itemMap[row.id] = insertion
              this.items.push(insertion)
            }
          })
        }))
        .then(() => resolve())
        .catch(error => {
          console.log(error)
          this.$root.$errorSnackbar(error)
          reject(error)
        })
        .then(() => {
          this.isLoading = false
        })
      })
    }
  },
  created () {
    this.loadAPI()
  }
}
</script>
